import { useApiDeleteRequest } from '@/api/rest/hooks/useApiDeleteRequest';
import { useApiPatchRequest } from '@/api/rest/hooks/useApiPatchRequest';
import { useApiPostRequest } from '@/api/rest/hooks/useApiPostRequest';

import {
  DELETE_PLOT_PORTFOLIO_PRODUCT_PATH,
  DeletePlotPortfolioProductErrorDto,
  DeletePlotPortfolioProductRequestPathVariables,
  PATCH_PLOT_PORTFOLIO_PRODUCT_PATH,
  PatchPlotPortfolioProductErrorDto,
  PatchPlotPortfolioProductRequestBodyData,
  PatchPlotPortfolioProductRequestPathVariables,
  PlotPortfolioProduct,
  POST_PLOT_PORTFOLIO_PRODUCT_PATH,
  PostPlotPortfolioProductErrorDto,
  PostPlotPortfolioProductRequestBodyData,
} from './types/plotPortfolioProducts';

export const usePostPlotPortfolioProduct = () => {
  return useApiPostRequest<
    undefined,
    undefined,
    PostPlotPortfolioProductRequestBodyData,
    PlotPortfolioProduct,
    PostPlotPortfolioProductErrorDto
  >(POST_PLOT_PORTFOLIO_PRODUCT_PATH);
};

export const usePatchPlotPortfolioProduct = () => {
  return useApiPatchRequest<
    PatchPlotPortfolioProductRequestPathVariables,
    undefined,
    PatchPlotPortfolioProductRequestBodyData,
    PlotPortfolioProduct,
    PatchPlotPortfolioProductErrorDto
  >(PATCH_PLOT_PORTFOLIO_PRODUCT_PATH);
};

export const useDeletePlotPortfolioProduct = () => {
  return useApiDeleteRequest<
    DeletePlotPortfolioProductRequestPathVariables,
    undefined,
    void,
    DeletePlotPortfolioProductErrorDto
  >(DELETE_PLOT_PORTFOLIO_PRODUCT_PATH);
};
